import {
	RESET_STATE,
	SET_ORDERS_LIST,
	SET_IS_ORDERS_LIST_LOADING,
	SET_PAGINATION,
	SET_MODES,
	SET_IS_MODES_LOADING,
	SET_GROUPS,
	SET_IS_GROUPS_LOADING,
	SET_STATUSES,
	SET_IS_STATUSES_LOADING,
} from './actions';

export const initialState = {
	ordersList: null,
	isOrdersListLoading: false,
	ordersWays: null,
	modes: null,
	isModesLoading: false,
	groups: null,
	isGroupsLoading: false,
	statuses: null,
	isStatusesLoading: false,
	pagination: null,
};

const ordersContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ORDERS_LIST:
			return {
				...state,
				ordersList: payload,
			};
		case SET_IS_ORDERS_LIST_LOADING:
			return {
				...state,
				isOrdersListLoading: payload,
			};
		case SET_MODES:
			return {
				...state,
				modes: payload,
			};
		case SET_IS_MODES_LOADING:
			return {
				...state,
				isModesLoading: payload,
			};
		case SET_GROUPS:
			return {
				...state,
				groups: payload,
			};
		case SET_IS_GROUPS_LOADING:
			return {
				...state,
				isGroupsLoading: payload,
			};
		case SET_STATUSES:
			return {
				...state,
				statuses: payload,
			};
		case SET_IS_STATUSES_LOADING:
			return {
				...state,
				isStatusesLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default ordersContainerReducer;
